import appStore from '../utils/state';
import type { CartState } from '../types';

export default class CartButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;
  private icon: HTMLElement | null = null;
  private count: HTMLElement | null = null;
  private countValue: HTMLElement | null = null;

  private unsubscribeFromCartUpdated: (() => void) | null = null;

  private onClickBound = this.onClick.bind(this);
  private onCartUpdatedBound = this.onCartUpdated.bind(this);

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.button = this.querySelector('[data-cart-button-ref="button"]');
    this.icon = this.querySelector('[data-cart-button-ref="icon"]');
    this.count = this.querySelector('[data-cart-button-ref="count"]');
    this.countValue = this.count?.querySelector('span') ?? null;

    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  subscribe(): void {
    this.unsubscribeFromCartUpdated = appStore.subscribeKey('cart', this.onCartUpdatedBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromCartUpdated) {
      this.unsubscribeFromCartUpdated();
      this.unsubscribeFromCartUpdated = null;
    }
  }

  onCartUpdated(cart: CartState): void {
    const itemCount = cart.data?.item_count ?? 0;
    const isEmpty = itemCount === 0;

    if (this.countValue) {
      this.countValue.textContent = String(itemCount);
    }

    this.icon?.classList.toggle('opacity-0', !isEmpty);
    this.icon?.classList.toggle('invisible', !isEmpty);
    this.count?.classList.toggle('opacity-0', isEmpty);
    this.count?.classList.toggle('invisible', isEmpty);
  }

  onClick(): void {
    appStore.actions.toggleCartModal();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
    this.unsubscribe();
  }
}

customElements.define('cart-button', CartButton);
